<script setup lang="ts">
import { FilterType } from '@enums/FilterType.ts';
import Button from '@components/Button.vue';
import Typography from '@components/Typography.vue';
import { useFilterStore } from '@stores/useFilterStore.ts';
import { trans } from '@tools/translation.ts';
import Icon from '@components/Icon.vue';
import { IconArrowRight } from '@icons';

const { type } = defineProps<{
  type: FilterType,
}>();

const filterStore = useFilterStore();
const { openMobileFilter } = filterStore;
</script>

<template>
  <Button
    :class="[
      '!flex cursor-pointer items-center justify-between',
      '!h-[62px] !p-3',
      '!rounded-none !border-0 !border-b border-solid border-gray'
    ]"
    @click="openMobileFilter(type)"
  >
    <div class="flex items-center gap-4">
      <slot name="icon" />

      <Typography variant="content-heading-2">
        {{ trans(`search.filters.${type}.title`) }}
      </Typography>
    </div>

    <Icon :svg="IconArrowRight" width="24" height="24" />
  </Button>
</template>
